import React from 'react';
import PageContainerWithLogo from '../Core/PageContainerWithLogo';

const RulesCarcassonne = () =>
{
  return (
    <PageContainerWithLogo>

      <div className="rules-container">
        <header className="rules-header">
          <h1>Base Game Rules</h1>
        </header>
        <div className="rules-content">
          <section>
            <h2>1. Components & Setup</h2>
            <p>
              The base game includes 72 land tiles, featuring different configurations of roads, cities, monasteries & fields.
            </p>
            <ul>
              <li>Each player picks a color and takes 7 tilefolk.</li>
            </ul>
          </section>

          <section>
            <h2>2. Turn Sequence</h2>
            <ol>
              <li>
                <strong>Draw & Place a Tile:</strong> Draw a tile and place it adjacent to at least one placed tile,
                matching features on connecting edges (road to road, city to city, field to field).
              </li>
              <li>
                <strong>Optional — Deploy one of your Tilefolk:</strong> You may place one of your available tilefolk on one of the
                features of the newly placed tile (road, city, monastery, or field), if that feature is not already claimed.
              </li>
              <li>
                <strong>Score Completed Features:</strong> After the tile (and optionally a tilefolk) have been placed,
                any feature(s) (road, city, monastery) that have become completed are then scored and the tilefolk on them are returned back to their owners.
              </li>
            </ol>
          </section>

          <section>
            <h2>3. Claiming Features</h2>
            <p>When placing a tilefolk, you may:</p>
            <ul>
              <li>Place it on a road (tilefolk stands upright, claiming as a “thief”).</li>
              <li>Place it on a city (tilefolk stands upright, claiming as a “knight”).</li>
              <li>Place it on a monastery (tilefolk stands upright, claiming as a “monk”).</li>
              <li>Place it on a field (tilefolk lies down, claiming as a “farmer”). <b>Fields score only at game end.</b></li>
            </ul>
            <p>
              You cannot place a tilefolk on a feature if that feature connects (via adjacent tiles) to any
              part already claimed by another player's tilefolk.
            </p>
          </section>

          <section>
            <h2>4. Completion & Scoring During Game</h2>
            <p>
              Features that are completed during your turn are scored immediately, before the turn ends:
            </p>
            <ul>
              <li><strong>Roads:</strong> Completed when both ends are closed or it forms a loop. Score 1 point per tile in that road.</li>
              <li><strong>Cities:</strong> Completed when edges are closed. Score 2 points per tile + 2 points per pennant badge.</li>
              <li><strong>Monasteries:</strong> Completed when all eight adjacent spaces are filled. Score 9 points (1 for the monastery + 8 around it).</li>
            </ul>
            <p>After scoring a completed feature, return all tilefolk on that feature to their owners.</p>
          </section>

          <section>
            <h2>5. End of Game & Final Scoring</h2>
            <p>
              The game ends when all tiles have been placed. Then, any incomplete features and all fields are scored:
            </p>
            <ul>
              <li><strong>Incomplete Roads:</strong> 1 point per tile.</li>
              <li><strong>Incomplete Cities:</strong> 1 point per tile + 1 per pennant badge.</li>
              <li><strong>Incomplete Monasteries:</strong> 1 point for the monastery + 1 for each surrounding tile.</li>
              <li><strong>Fields:</strong> Each completed city adjacent to a field is worth 3 points. Only the player(s)
                with the most farmers in a field score for that field.</li>
            </ul>
          </section>

          <section>
            <h2>6. Winning the Game</h2>
            <p>The player with the highest total points after final scoring is the winner.</p>
          </section>

          <section>
            <h2>7. Strategy Tips</h2>
            <p>
              — Don’t deploy all your tilefolk too early; keep some in reserve.<br />
              — Try to complete roads or cities quickly to reclaim tilefolk.<br />
              — Monasteries are powerful if you can surround them fast.<br />
              — Farming is valuable but ties up tilefolk until the end of the game.<br />
            </p>
          </section>
        </div>
      </div>
    </PageContainerWithLogo>
  );
};

export default RulesCarcassonne;
